import { LegalShell, H } from "@/components/LegalShell";

export default function Privacy() {
  return (
    <LegalShell title="Privacy Policy" updated="June 2026">
      <section data-testid="privacy-content">
        <p>
          Wellness Way with DJ ("we", "us") respects your privacy. This policy explains what
          information we collect through wellnesswaywithdj.com and how we use it.
        </p>
      </section>
      <section>
        <H>Information we collect</H>
        <p className="mt-3">
          <strong>Information you give us:</strong> your name and email when you request our free
          guide or join our list; the details you share in a coaching application (including goals
          and general health information you choose to provide); and account information if you
          become a member (login credentials, progress data, messages).
        </p>
        <p className="mt-3">
          <strong>Payments:</strong> all payments are processed by Stripe (and its supported
          payment options such as Klarna, Affirm, and PayPal). We never see or store your full
          card details.
        </p>
      </section>
      <section>
        <H>How we use it</H>
        <p className="mt-3">
          To deliver what you asked for (your guide, your application review, your coaching
          program), to send you relevant emails about your program and our offerings, and to
          operate and improve the member experience. Health information you share is used solely
          to provide coaching services.
        </p>
      </section>
      <section>
        <H>What we don't do</H>
        <p className="mt-3">
          We do not sell, rent, or trade your personal information. We only share data with the
          service providers that make this site work (hosting, email delivery, payment
          processing), and only as needed.
        </p>
      </section>
      <section>
        <H>Emails</H>
        <p className="mt-3">
          You can opt out of marketing emails anytime using the unsubscribe link in any email, or
          by contacting us directly. Transactional emails (like payment confirmations and account
          access) will still be sent.
        </p>
      </section>
      <section>
        <H>Data retention &amp; your rights</H>
        <p className="mt-3">
          We keep your information only as long as needed to provide services. You may request a
          copy of your data or ask us to delete it at any time by emailing
          {" "}<a href="mailto:dj@djheningerfitness.com" style={{ color: "#A89880" }}>dj@djheningerfitness.com</a>.
        </p>
      </section>
      <section>
        <H>Cookies</H>
        <p className="mt-3">
          We use essential cookies to keep members signed in, and simple local storage to remember
          things like whether you've already seen our guide offer. We don't run third-party ad
          trackers.
        </p>
      </section>
      <section>
        <H>Contact</H>
        <p className="mt-3">
          Questions? Email <a href="mailto:dj@djheningerfitness.com" style={{ color: "#A89880" }}>dj@djheningerfitness.com</a>.
        </p>
      </section>
    </LegalShell>
  );
}
